import i18n from '@/i18n';

// 翻訳キーから値を取得するヘルパー関数
const t = (key) => {
    try {
        return i18n.global.t(key);
    } catch (e) {
        return '';
    }
};

// 録音を開始する関数
export const startRecording = async (audioSettings) => {
    return new Promise((resolve, reject) => {

        const {
            recordingTime,
            sampleRate,
            bitDepth,
            channels
        } = audioSettings;

        // 録音状態を管理するオブジェクト
        const recordingState = {
            recording: false,
            audioChunks: [],
            mediaRecorder: null,
        };
        // マイクアクセスに成功したときのコールバック関数
        const handleSuccess = (stream) => {
            recordingState.mediaRecorder = new MediaRecorder(stream);
            recordingState.mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    recordingState.audioChunks.push(event.data);
                }
            };
            // 音声データの変換と解析を実行
            recordingState.mediaRecorder.onstop = () => {
                convertAudio().then(resolve).catch(reject);
            };
            // 録音開始
            recordingState.audioChunks = [];
            recordingState.mediaRecorder.start();
            recordingState.recording = true;
            // 一定時間経過後に録音停止
            setTimeout(() => {
                stopRecording();
            }, recordingTime);
        };
        // マイクアクセスに失敗したときのコールバック関数
        const handleError = (error) => {
            console.error('マイクへのアクセスエラー:', error);
            reject(t('errors.microphone_access_error'));
        };
        // 録音停止
        const stopRecording = () => {
            if (recordingState.mediaRecorder && recordingState.recording) {
                recordingState.mediaRecorder.stop();
                recordingState.recording = false;
            }
        };
        // 音声データをWave形式に変換
        const convertAudio = async () => {
            const audioBlob = new Blob(recordingState.audioChunks);
            return webmToWav(audioBlob);
        };

        //録音データをwave形式に変換
        const webmToWav = (blob) => {
            return new Promise((resolve) => {
                const audioContext = new (window.AudioContext || window.webkitAudioContext)();
                const reader = new FileReader();

                reader.onloadend = async () => {
                    const arrayBuffer = reader.result;
                    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

                    //サンプリングレート変更に対する変換秒数を指定
                    const targetSampleCount = Math.floor((recordingTime * sampleRate) / 1000);
                    const sourceSampleCount = Math.min(audioBuffer.length, targetSampleCount);
                    const offlineContext = new OfflineAudioContext(channels, sourceSampleCount, sampleRate);
                    const source = offlineContext.createBufferSource();
                    source.buffer = audioBuffer;

                    offlineContext.oncomplete = (event) => {
                        //データサイズ：8bit(sampleBuffer.length) * 2
                        const sampleBuffer = event.renderedBuffer;
                        const wavBlob = new Uint8Array(44 + sampleBuffer.length * 2);
                        const view = new DataView(wavBlob.buffer);

                        // WAVヘッダの設定
                        view.setUint8(0, 'R'.charCodeAt(0));
                        view.setUint8(1, 'I'.charCodeAt(0));
                        view.setUint8(2, 'F'.charCodeAt(0));
                        view.setUint8(3, 'F'.charCodeAt(0));
                        view.setUint32(4, 36 + sampleBuffer.length * 2, true);
                        view.setUint8(8, 'W'.charCodeAt(0));
                        view.setUint8(9, 'A'.charCodeAt(0));
                        view.setUint8(10, 'V'.charCodeAt(0));
                        view.setUint8(11, 'E'.charCodeAt(0));
                        view.setUint8(12, 'f'.charCodeAt(0));
                        view.setUint8(13, 'm'.charCodeAt(0));
                        view.setUint8(14, 't'.charCodeAt(0));
                        view.setUint8(15, ' '.charCodeAt(0));
                        view.setUint32(16, 16, true); // PCMフォーマットのヘッダサイズ
                        view.setUint16(20, 1, true); // フォーマットID
                        view.setUint16(22, channels, true); // チャンネル数
                        view.setUint32(24, sampleRate, true); // サンプリングレート
                        view.setUint32(28, sampleRate * 2, true); // データ速度 (サンプリングレート * ブロックサイズ)
                        view.setUint16(32, 2, true); // ブロックサイズ
                        view.setUint16(34, bitDepth, true); // サンプルあたりのビット数
                        view.setUint8(36, 'd'.charCodeAt(0));
                        view.setUint8(37, 'a'.charCodeAt(0));
                        view.setUint8(38, 't'.charCodeAt(0));
                        view.setUint8(39, 'a'.charCodeAt(0));
                        view.setUint32(40, sampleBuffer.length * 2, true);

                        // PCMデータの書き込み
                        for (let i = 0; i < sampleBuffer.length; i++) {
                            const offset = 44 + i * 2;
                            const sample = sampleBuffer.getChannelData(0)[i];
                            const pcmSample = Math.max(-1, Math.min(1, sample));
                            view.setInt16(offset, pcmSample < 0 ? pcmSample * 0x8000 : pcmSample * 0x7fff, true);
                        }
                        resolve(new Blob([wavBlob]));
                    };
                    source.connect(offlineContext.destination);
                    source.start();
                    offlineContext.startRendering();
                };
                reader.readAsArrayBuffer(blob);
            });
        };
        // ユーザーにマイクのアクセスを要求
        navigator.mediaDevices.getUserMedia({ audio: true }).then(handleSuccess).catch(handleError);
    });
};